var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"subheader"},[_c('h1',{staticClass:"subheader__title tp-m-deci"},[_vm._v("Holding")]),_c('h2',{staticClass:"subheader__subtitle tp-r-centi"},[_vm._v(_vm._s(_vm.lHolding.desholding))])])}
var staticRenderFns = []

export { render, staticRenderFns }